import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg viewBox="0 0 1024 1024" {...props} fill={'none'} stroke={'none'}>
    <Path
      fill={props.fill || '#000'}
      d="M384 689.92 206.08 512l-60.373 60.373L384 810.667l512-512-60.373-60.374z"
    />
  </Svg>
);
export default SvgComponent;
